import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import PageNotFound from '@/components/PageNotFound'
import Register from '@/components/Register'
import Dashboard from '@/components/Dashboard'
import Inbox from '@/components/Inbox'
import Scheduled from '@/components/Scheduled'
import DentistProfile from '@/components/DentistProfile'
import ReportProblem from '@/components/ReportProblem'
import DentalRadar from '@/components/DentalRadar'
import UserPage from '@/components/UserPage'
import Patients from '@/components/patients'
import Appointment from '@/components/appointment'
import Card from '@/components/Card'
import Viewer from '@/components/Viewer'
import Timeline from '@/components/Timeline'
import Messages from '@/components/Messages'
import AssignBalance from '@/components/AssignBalance'
import Services from '@/components/Services'

// admin pages
import Admin from '@/components/Admin'
import Settings from '@/components/Settings'
import Media from '@/components/Media'
import Pages from '@/components/Pages'
import Users from '@/components/Users'
import Blocks from '@/components/Blocks'
import BlockPage from '@/components/BlockPage'

import { store } from '@/store/index'



Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    { path: "*", component: PageNotFound },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/',
      name: 'register',
      component: Register,
    },
    {
      path: '/viewer',
      name: 'viewer',
      component: Viewer,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/services',
      name: 'services',
      component: Services
    },
    {
      path: '/assign-balance',
      name: 'assign balance',
      component: AssignBalance
    },
    {
      path: '/messages*',
      name: 'messages',
      component: Messages
    },
    {
      path: '/timeline',
      name: 'timeline',
      component: Timeline
    },
    {
      path: '/patients',
      name: 'patients',
      component: Patients
    },
    {
      path: '/appointment',
      name: 'appointment',
      component: Appointment
    },
    { path: "/user*", component: UserPage },
    { path: "/card*", component: Card },

    {
      path: '/inbox',
      name: 'inbox',
      component: Inbox,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/scheduled',
      name: 'scheduled',
      component: Scheduled,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dentist-profile',
      name: 'dentist profile',
      component: DentistProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report-problem',
      name: 'report problem',
      component: ReportProblem,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dental-radar*',
      name: 'dental radar',
      component: DentalRadar,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      children: [
        { path: 'settings', component: Settings },
        { path: 'media', component: Media },
        { path: 'pages', component: Pages },
        { path: 'blocks', component: Blocks },
        { path: 'users', component: Users },
        { path: 'blocks/*', component: BlockPage }


        // { path: 'pages', component: Pages },
        // { path: 'users', component: Users }
      ],
    },
  ],
  scrollBehavior (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
}
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (store.getters.loggedIn) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js